<script setup lang="ts"></script>

<template>
  <span
    class="absolute inline-flex items-center gap-1 whitespace-nowrap py-[1px] text-sm text-skin-text"
  >
    <i-s-voted class="text-green" />
    {{ $t('voted') }}
  </span>
</template>
